export default __webpack_public_path__ + "static/media/delete.3c63a97c.mp3";